import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { Select, Tabs } from "antd"
import { ROLE_MANDU_ADMIN } from "../../../../utils/constants"

const { TabPane } = Tabs
const { Option } = Select

const typeTabShow = (tabsSuperAdmin, tabsAdmin, idRole) => {
  const toMap = idRole === ROLE_MANDU_ADMIN ? tabsAdmin : tabsSuperAdmin
  return toMap.map((item) => (
    <TabPane tab={item.name} key={item.key}>
      {item.content}
    </TabPane>
  ))
}

const TabsUserMandu = (props) => {
  const { tab, isNew, currentData } = props
  const { id_role } = currentData
  const { setSelectedTab, tabsSuperAdmin, tabsAdmin } = props
  return (
    <Fragment>
      {!isNew && (
        <Tabs
          style={{ margin: "-24px -24px auto" }}
          // animated={false}
          activeKey={tab}
          onChange={(e) => setSelectedTab(e)}>
          {typeTabShow(tabsSuperAdmin, tabsAdmin, id_role)}
        </Tabs>
      )}
    </Fragment>
  )
}

TabsUserMandu.propTypes = {
  isNew: PropTypes.bool,
  tab: PropTypes.string,
  currentData: PropTypes.object,
  tabsSuperAdmin: PropTypes.array,
  tabsAdmin: PropTypes.array,
  setSelectedTab: PropTypes.func,
}

export default TabsUserMandu
